<script setup>
import { isNull } from 'lodash'

import { BINARY_OPTIONS } from '@/utils/components-configurations/okr-grade'
import { DATA_TYPES } from '@/utils/data-types'

import AppRadioGroup from '@/components/ui/AppRadioGroup/AppRadioGroup'
import AppRadioGroupNextOptionWithIcon from '@/components/ui/AppRadioGroup/AppRadioGroupNextOptionWithIcon'

defineOptions({
  name: 'BinaryValueSwitch'
})

const model = defineModel({
  validator: v =>
    [DATA_TYPES.STRING, DATA_TYPES.NUMBER, DATA_TYPES.BOOLEAN].includes(typeof v) || isNull(v),
  required: true,
  set: v => v
})

defineProps({
  disabled: {
    type: Boolean
  }
})
</script>

<template>
  <AppRadioGroup
    v-model="model"
    :class="{ [$attrs.class]: Boolean($attrs.class) }"
    :data-auto-testid="$attrs['data-auto-testid'] || 'binary-switch'"
    :data-testid="$attrs['data-testid'] || 'binary-switch'"
    :disabled
    :name="$attrs.name || 'binary-type'"
    :options="BINARY_OPTIONS"
    align-width
    class="bvs-Switch"
    full-width
    style="--fill: var(--grey-2-next); --option-padding: 4px 8px 4px 0"
  >
    <template #item-label="{ item }">
      <AppRadioGroupNextOptionWithIcon :option="item" centered />
    </template>
  </AppRadioGroup>
</template>

<style lang="scss" scoped>
.bvs-Switch {
  --option-font-size: #{$fs-14};
  --option-font-weight: #{fw('semi-bold')};
}
</style>
